import React from 'react';
import TechnicalInformation from './ProductTabs/TechnicalInformation';
import BlankLoader from '../../components/Common/BlankLoader';
import LKModal from '../Modal/Modal';
import './TechInfoData.scss';

class TechInfoData extends React.Component {
  constructor() {
    super();
    this.state = {
      showTechInfo: false,
      showCmsDataModal: false,
    };
    this.showTechInfoHandler = this.showTechInfoHandler.bind(this);
    this.openModalBox = this.openModalBox.bind(this);
  }

  openModalBox = value => {
    this.setState({ showCmsDataModal: true });
    this.props.getCmsPageData(value);
  };

  close = () => {
    this.setState({ showCmsDataModal: false });
  };

  showTechInfoHandler() {
    const { showTechInfo } = this.state;
    this.setState({
      showTechInfo: !showTechInfo,
    });
  }

  render() {
    const { productData, cmsPopUpData, getCmsPageData, dataLocale, localeInfo } = this.props;
    const { domain } = localeInfo;
    const { showTechInfo } = this.state;
    const {
      TECHNICAL_INFORMATION,
      SHOW_ALL_INFO,
      WATCH_VIDEO,
      PRODUCT_ID,
      CLOSE,
      LEGAL_DETAILS,
      POWER_SUPPORTED,
    } = dataLocale;
    const generalInfo = productData?.specifications[0];
    const techInfoData =
      generalInfo &&
      generalInfo?.items?.slice(0, 5).map((information, index) => {
        return (
          <div key={index} className="display-flex padding-b5">
            <span className="info-text text-color-66 width-135">{information.name}</span>
            <span className="info-text text-color-black fw500 padding-l10 fs13">
              {information.name !== 'Video' &&
              information.urlDetails &&
              information.urlDetails.label === '' ? (
                <a className="defadivt-color" href={information.urlDetails.url}>
                  {information.value}
                </a>
              ) : (
                <span className="">{information.value}</span>
              )}
              {information.name !== 'Video' &&
              information.urlDetails &&
              information.urlDetails.label !== '' ? (
                <span
                  aria-label="open size modal"
                  className="fs12 size-chart cursor-pointer"
                  onClick={() => {
                    this.openModalBox(
                      information.urlDetails.url
                        .replace('https://www.lenskart.com/', '')
                        .replace(domain, '')
                    );
                  }}
                >
                  <i className="fa fa-question-circle fs15 padding-l5"></i>
                </span>
              ) : (
                ''
              )}
              {information.name === 'Video' && information.value !== 'NO' ? (
                <a
                  className="fs12 default-color size-video"
                  href={this.state.videoUrlName}
                  onClick={this.videoUrl(this, information.value)}
                >
                  {WATCH_VIDEO}
                </a>
              ) : (
                ''
              )}
            </span>
          </div>
        );
      });
    if (productData?.supportedPowers) {
      techInfoData.push(
        <div className="display-flex padding-b5">
          <span className="info-text text-color-66 width-135">{POWER_SUPPORTED}</span>
          <span className="info-text text-color-black fw500 padding-l10 fs13">
            {productData?.supportedPowers}
          </span>
          {productData?.supportedPowersCmsLink && (
            <span
              aria-label="open size modal"
              className="fs12 size-chart cursor-pointer"
              onClick={() => {
                this.openModalBox(
                  productData?.supportedPowersCmsLink
                    .replace('https://www.lenskart.com/', '')
                    .replace(domain, '')
                );
              }}
            >
              <i className="fa fa-question-circle fs15 padding-l5"></i>
            </span>
          )}
        </div>
      );
    }

    return (
      <React.Fragment>
        {productData?.id && (
          <div className="display-flex padding-b5">
            <span className="info-text text-color-66 width-135">{PRODUCT_ID}</span>
            <span className="info-text text-color-black fw500 padding-l10 fs13">
              {productData.id}
            </span>
          </div>
        )}
        <div>{techInfoData}</div>
        {productData?.clLegalreqDetails && (
          <div className="display-flex padding-b5">
            <span className="info-text text-color-66 width-135">{LEGAL_DETAILS}</span>
            <span dangerouslySetInnerHTML={{ __html: productData.clLegalreqDetails }}></span>
          </div>
        )}
        <div
          aria-label="show tech info btn"
          className="text-color-primary fs13 cursor-pointer padding-t10 display-ib"
          onClick={() => this.showTechInfoHandler()}
        >
          {SHOW_ALL_INFO}
        </div>
        {showTechInfo && (
          <LKModal
            backdrop
            keyboard
            dialogClassName="tech-info-modal"
            hideHandler={() => this.showTechInfoHandler()}
            showModal={showTechInfo}
          >
            <div
              aria-label="technical information"
              className="display-flex align-items-center margin-b20"
            >
              <div className="tryon-title fs28">{TECHNICAL_INFORMATION}</div>
              <div aria-label="close btn" onClick={() => this.showTechInfoHandler()}>
                <img alt={CLOSE} className="cursor-pointer" src="/assets/svg/Cross.svg" />
              </div>
            </div>
            <TechnicalInformation
              TechnicalInformation={productData.specifications}
              cmsPopUpData={cmsPopUpData}
              getCmsPageData={getCmsPageData}
              localeInfo={localeInfo}
              openModalBox={this.openModalBox}
            />
          </LKModal>
        )}
        {this.state.showCmsDataModal && (
          <LKModal
            backdrop
            keyboard
            hideHandler={this.close}
            showModal={this.state.showCmsDataModal}
            size="large"
          >
            <div className="cmsdata-modal" data-testid="contentManagementData">
              <div
                aria-label="close button"
                className="close-me-btn"
                onClick={() => {
                  this.setState({ showCmsDataModal: false });
                }}
              ></div>
              {this.props.cmsPopUpData ? (
                <div dangerouslySetInnerHTML={{ __html: this.props.cmsPopUpData }}></div>
              ) : (
                <BlankLoader />
              )}
            </div>
          </LKModal>
        )}
      </React.Fragment>
    );
  }
}

export default TechInfoData;
